// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__rFnqS","name":"ConsentHeader_name__3PCJI","birthday":"ConsentHeader_birthday__3Hukc","skeleton":"ConsentHeader_skeleton__dBvYD"};